import { BsFillGridFill } from "react-icons/bs";
import { packageIcon } from "../base";
import { multilingualBlockContentPreview } from "../base/multilingualArrayBlockContent";
import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Custom Offer Box Item",
  name: "customOfferBoxItem",
  type: "object",
  icon: BsFillGridFill,
  fields: [
    {
      name: "promo",
      title: "Promo",
      type: "reference",
      to: [{ type: "exclusiveOfferPerPromo" }],
      description: "Select a promo to use default content and tokens"
    },
    {
      name: "icon",
      title: "Icon",
      type: packageIcon.name
    },
    {
      title: "Title",
      name: "title",
      type: "multilingualArrayString"
    },
    {
      title: "Text",
      name: "text",
      type: "multilingualArrayBlockContent"
    }
  ],
  preview: {
    select: {
      title: "title",
      subtitle: "text",
      icon: "icon"
    },
    prepare: ({ title, subtitle, icon }) => ({
      title: `[${icon}] ${multilingualStringPreview(title)}`,
      subtitle: multilingualBlockContentPreview(100)(subtitle)
    })
  }
});
